import React from 'react'
import { useSelector } from 'react-redux'

import railsContext from 'lib/selectors/rails-context'

import { legalData } from '../constants'

const LegalBits = () => {
  const { i18nLocale: locale } = useSelector(railsContext)
  const content = legalData[locale]

  if (!content) return null

  return (
    <div className='row'>
      <div className='twelve columns'>
        <h1 className='page-title'>{content.title}</h1>
        <div className='widget space'>
          <h4>{content.addressTitle}</h4>
          <span>{content.companyName}</span>
          <br />
          {content.addressLines.map((line, index) => (
            <React.Fragment key={index}>
              <span>{line}</span>
              <br />
            </React.Fragment>
          ))}
          <br />
          <h4>{content.companyTitle}</h4>
          <span>{content.companyNumber}</span>
        </div>
      </div>
    </div>
  )
}

export default LegalBits
